import type { ReconciliationScope } from '../reconciliation-scope';

export const ReconciliationOutcome = {
  Completed: 'completed',
  Failed: 'failed',
  /** rejected by the processor because a newer direct edit landed on the same cell */
  Superseded: 'superseded',
} as const;

export type ReconciliationOutcome =
  (typeof ReconciliationOutcome)[keyof typeof ReconciliationOutcome];

export interface ConsensusReconciliationSseEventPayload {
  consensusTemplateId: string;
  consensusColumnId: string;
  /** yyyy-MM — identifies which month column the reconciliation is for. */
  dateValue: string;
  /**
   * Filter scope of the reconciliation. Replaces the previous
   * `uniqueCombinationPaths: string[]` which materialised every affected
   * leaf + aggregate row up-front. Frontend evaluates per-row matches via
   * {@link rowMatchesScope}.
   */
  scope: ReconciliationScope;
  isReconciling: boolean;
  /** the planner whose edit started the reconciliation */
  userId: string;
  jobId: string;
  /** only on the end event (`isReconciling: false`) */
  outcome?: ReconciliationOutcome;
}
